module.exports = __webpack_public_path__ + "img/giropay1.cf01b374.png";